// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CreateSubscriptionPrice_closeButton__1dgJJ"};